import React from "react";
import LoginStepComponent from "./components/login.component";
import { useCreateContext } from "./provider/create.provider";
import Code2FAStepComponent from "./components/code.component";
import CreateNewsComponent from "./news/create.news.component";
import { useCreateNewsContext } from "./news/provider/createNews.provider";
import { useCreateUsedContext } from "./used/provider/createUsed.provider";
import RecoverStep from "./components/recover.component";
import CreateSimplyComponent from "./simply/create-simply.component";

const CreateMiCeluComponent = () => {
  const { flow, step } = useCreateContext();
  const { step: stepNews } = useCreateNewsContext();
  const { step: stepUsed } = useCreateUsedContext();

  return (
    <>
      {step < 5 ? (
        <div
          className={`mx-auto mt-10 w-2/3 lg:px-10 ${step !== 3 && "rounded-xl bg-white py-5 shadow-xl"}`}
        >
          <div className="mx-auto w-5/6 overflow-hidden pt-10 lg:w-3/4">
            {step === 1 && <LoginStepComponent />}
            {step === 2 && <Code2FAStepComponent />}
            {/*   {step === 3 && <SelectFlowComponent />} */}
            {step === 4 && <RecoverStep />}
          </div>
        </div>
      ) : (
        <>
          <div
            className={`flex w-full md:mt-80 md:flex-col lg:mt-72 xl:mt-44 xl:flex-row 2xl:mt-0 ${stepUsed === 3 && "md:mt-96 lg:mt-96 xl:mt-80"} ${stepNews === 2 && "md:mt-96 lg:mt-96 xl:mt-80"}`}
          >
            <div className="w-full rounded-xl bg-white py-5 shadow-xl md:-mt-1 lg:px-10 xl:mt-10">
              <div className="mx-auto w-5/6 overflow-hidden pt-10 lg:w-3/4">
                <CreateSimplyComponent />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
export default CreateMiCeluComponent;
